export default "/images/GDPR_Logo.png";